import { Checkbox, type CheckboxRootProps, LuIcon, stopPropagation } from "@overmap-ai/blocks"
import { memo } from "react"

import { modelIconMapping } from "../../../mappings/icons"

interface RowSelectCheckboxProps extends Omit<CheckboxRootProps, "checked" | "onCheckedChange" | "children"> {
	isRowSelected: boolean
	toggleRowSelected: (value: boolean) => void
}

export const RowSelectCheckbox = memo<RowSelectCheckboxProps>((props) => {
	const { isRowSelected, toggleRowSelected, size = "sm", accentColor = "base", ...rest } = props

	return (
		<Checkbox.Root
			checked={isRowSelected}
			onCheckedChange={toggleRowSelected}
			aria-label="Select row"
			size={size}
			accentColor={accentColor}
			onClick={stopPropagation}
			{...rest}
		>
			<Checkbox.Indicator>
				<LuIcon icon={modelIconMapping.check} />
			</Checkbox.Indicator>
		</Checkbox.Root>
	)
})
RowSelectCheckbox.displayName = "RowSelectCheckbox"
